import useTableRequest from "../../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { usersCourseEnrollmentsReportColumns } from "../../../constant/tables-columns/tablesColums";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import moment from "jalali-moment";
import UserCourseEnrollmentsReportsFilter from "./UserCourseEnrollmentsReportsFilter";

export default function UsersCourseEnrollmentsReport() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [userReportsData, setUsersReportsData] = useState([]);
 
  const getProductReports = async (params) => {
    const path = "admin/reports/userCourseEnrollments";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setUsersReportsData(response?.data?.result);
    });
  };

  useEffect(() => {
    getProductReports({});
  }, []); 
  useEffect(() => {
    filterDataHandler({ from: moment().locale('en').format('YYYY-MM-DD'), to: moment().locale('en').format('YYYY-MM-DD') });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };
 
  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزارش خریداران دوره"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel disabled={tableRequest.status !== "success"} jsonData={userReportsData} />
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">خریداران دوره‌ها را در بازهٔ تاریخ انتخابی نشان می‌دهد.</p>
      <UserCourseEnrollmentsReportsFilter filterDataHandler={filterDataHandler} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={usersCourseEnrollmentsReportColumns} rows={userReportsData} />
    </div>
  );
}
